import { dispatch } from "../state/store";
import { setAppSettings, setLoading as appSetLoading, setReady } from "../state/ducks/app";
import { httpClient } from "./httpClient";
import {api} from '../constants/app_constants';
import {api as rolesApi} from '../constants/roles';
import log from "./logger/log";
import { setRolesData } from "../state/ducks/roles";
import { AccessLevel, AppModules } from "../constants/appAccess";

const convertValue = function(rawValue, dataType) {
    if (!rawValue) return rawValue;
    if (dataType === "Boolean") {
        return rawValue.toLowerCase() === "true";
    }

    if (dataType === "Integer") {
        return parseInt(rawValue);
    }

    return rawValue;
};

const getAppSettings = async () => {    
    const url = api.GET_APP_SETTINGS;

    try {
        const data = await httpClient.get(url);
        const appSettings = {
            applicationSettings: data.applicationSettings.map((setting, index) => { return { name: setting.name, value: convertValue(setting.value, setting.dataType)}}),
            deviceTypes: data.deviceTypes,
            ioTypes: data.ioTypes,
            ioActionTypes: data.ioActionTypes,
            appModulesAccess: data.appModulesAccess,
            appFieldsAccess: data.appFieldsAccess,
        }
        dispatch(setAppSettings(appSettings));

        const administrationAccess = appSettings.appModulesAccess[AppModules.Administration];

        if(administrationAccess === AccessLevel.Write){
            await getRolesData();
        }        
    } catch (error) {
        log.error(JSON.stringify(error));
        setLoading(false);
        // dispatch({ type: actions.HANDLE_ERROR, error });
    } 
}

const getRolesData = async () => {
    const url = rolesApi.GET_ROLES_DATA;
    try{
        const data = await httpClient.get(url);
        dispatch(setRolesData(data.roles, data.claims));
    }
    catch (error){
        log.error(JSON.stringify(error));
    }
}

const setLoading = (isLoading) => {
    dispatch(appSetLoading(isLoading));
}

const setAppReady = (isReady) => {
    dispatch(setReady(isReady));
}


// const clearError = () => {
//     dispatch({ type: actions.CLEAR_ERROR });
// }


const appService = {
    getAppSettings,
    setLoading,
    setAppReady
}

export default appService;